//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Builder.js";
let d=[[[0,"BoardFile",1,0],[0,"BoardOnly",1,0],[0,"EcadLocation",1,0],[0,"EcadNumber",1,0],[0,"EcadRevision",1,0],[0,"FileFormat",1,0],[0,"FileUnits",1,0],[0,"LibraryFile",1,0],[0,"ShowLog",1,0],[0,"UseCurrentWorkPart",1,0],[0,"UseEntityFilter",1,0]],[[[],"GetEntityFilter",{R_:{filter:"PcbExchange.EntityFilter"}},0,0],[["filter"],"SetEntityFilter",{},1,0],[[],"GetAreaMapping",{R_:{areaMapping:"PcbExchange.AreaMapping"}},0,0],[["areaMapping"],"SetAreaMapping",{},1,0],[[],"RunPreExportEcadHook",{},0,0]],[]];
SPLM.PcbExchange.EcadExportBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.EcadExportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PcbExchange.EcadExportBuilder.FileFormatEnum = Object.freeze({
    "Idf2" : "Idf2", "Idf3" : "Idf3", "Idf4" : "Idf4", "Zbmb" : "Zbmb", "Zpcb" : "Zpcb", "Idx2" : "Idx2", "Idx3" : "Idx3", "Idx4" : "Idx4", "Idx5" : "Idx5"});

SPLM.PcbExchange.EcadExportBuilder.EcadLocationEnum = Object.freeze({
    "Os" : "Os", "Tc" : "Tc"});

SPLM.PcbExchange.EcadExportBuilder.ExportUnitsEnum = Object.freeze({
    "Mm" : "Mm", "Thou" : "Thou"});

export default SPLM;